import { Reveal } from "@/components/Reveal";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <section className="bg-cream py-14 sm:py-20" data-testid="terms-hero">
        <div className="container-site max-w-3xl">
          <Reveal>
            <p className="label-eyebrow mb-5">Poolside Cooking</p>
            <h1 className="font-display font-black tracking-tight leading-[1.02] text-3xl sm:text-4xl lg:text-5xl text-ink">
              Terms of <span className="text-pool">Use.</span>
            </h1>
          </Reveal>
        </div>
      </section>
      <section className="bg-white py-12 sm:py-16">
        <div className="container-site max-w-3xl space-y-8 text-slate-600 text-sm sm:text-base leading-relaxed">
          <div>
            <h2 className="font-display font-bold text-lg text-ink mb-2">Using this website</h2>
            <p>
              This website is the official digital home of Poolside Cooking. Content — including photos, videos,
              recipes and merchandise designs — is the property of Poolside Cooking and may not be reproduced
              without permission.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-ink mb-2">Submissions &amp; applications</h2>
            <p>
              Applications submitted through Be on the Show, casting forms or contact forms do not guarantee an
              appearance, booking or response. By submitting, you confirm the information and materials you provide
              are yours to share.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-ink mb-2">Purchases</h2>
            <p>
              Merchandise and gift card purchases are processed securely by our payment provider. Orders, shipping
              and fulfillment details are confirmed by email at the time of purchase.
            </p>
          </div>
          <p className="text-xs text-slate-400">Last updated: October 2026</p>
        </div>
      </section>
    </div>
  );
}
